import { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import {NavLink} from "react-router-dom";
import "../css/Menu.css"
import { FaBars } from 'react-icons/fa';


export default function MyMenu(props) {
  const isMobile = window.innerWidth <= 799;
  const [isOpen, setIsOpen] = useState(false);

  const handleStateChange = (state) => {
    setIsOpen(state.isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>

      {isMobile && (
          <>
            <p onClick={toggleMenu} className="menu-button">
           <FaBars size={20} />サイトの目次を開く
            </p>
            <Menu isOpen={isOpen} onStateChange={handleStateChange}>
              <NavLink className="menu-item" activeClassName="active" exact to="/" onClick={closeMenu}>ホーム</NavLink>
              <NavLink className="menu-item" activeClassName="active" exact to="/Ship" onClick={closeMenu}>船の紹介</NavLink>
              <NavLink className="menu-item" activeClassName="active" exact to="/Plan" onClick={closeMenu}>釣り物・料金</NavLink>
              <NavLink className="menu-item" activeClassName="active" exact to="/Reserve" onClick={closeMenu}>空き状況</NavLink>
              <NavLink className="menu-item" activeClassName="active" exact to="/Schedule" onClick={closeMenu}>当日の流れ</NavLink>
            </Menu>
          </>
      )}
    </div>
  );
}
